<template>
  <div class="wrapper">
    <img class="topImg"
         :src="require('@/assets/images/企业动态banner.png')" />
    <div class="centerBox">
      <div class="tabsBox">
        <div v-for="(item, i) in timeList"
             :key="i"
             :class="item === timeCurrent ? 'active' : ''"
             @click="changeTime(item)">
          {{ item }}
        </div>
      </div>
      <div v-for="(item, i) in businessList"
           :key="i"
           class="itemBox">
        <div class="itemImgBox">
          <img :src="item.fileLocal + item.fileUrl" />
        </div>
        <div>
          <div class="title"
               @click="detailFn(item)">
            {{ item.title }}
          </div>
          <div class="subheading">发布于 {{ item.releaseTime }}</div>
          <div class="more"
               @click="detailFn(item)">></div>
        </div>
      </div>

      <el-row class="pageBox">
        <el-col :span="24"
                style="text-align: end">
          <el-pagination :current-page="pageCurrent"
                         :page-size="5"
                         background
                         layout="prev, pager, next"
                         @current-change="getBusinessFn"
                         :pager-count="5"
                         :total="total" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { queryTimeline, getBusiness } from "./server";
export default {
  name: "enterprise",
  data () {
    return {
      total: 0,
      pageCurrent: 1,
      pageSize: 5,
      timeList: [],
      timeCurrent: "",
      businessList: [],
    };
  },
  created () {
    this.init();
  },
  methods: {
    detailFn (row) {
      this.$router.push(`/detail?id=${row.businessId}`);
    },
    currentPageChange () { },
    init () {
      queryTimeline().then((res) => {
        if (res.data[0] !== null) {
          this.timeList = res.data;
          this.timeCurrent = res.data[0];
          this.getBusinessFn();
        }
      });
    },
    getBusinessFn () {
      getBusiness({
        t: {
          publishStatus: "1",
          releaseDateYear: this.timeCurrent,
        },
        p: {
          pageNum: this.pageCurrent,
          pageSize: this.pageSize,
        },
      }).then((res) => {
        console.log(res);
        this.businessList = res.rows;
      });
    },

    changeTime (item) {
      this.timeCurrent = item;
      this.pageCurrent = 1;
      this.getBusinessFn();
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
@media (min-width: 1024px) {
  .topImg {
    width: 100%;
  }
  .centerBox {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .tabsBox {
      width: 1200px;
      display: flex;
      justify-content: flex-end;
      color: #4a4a4a;
      margin-top: 90px;
      > div {
        font-size: 24px;
        font-weight: 300;
        margin-left: 59px;
        cursor: pointer;
      }
      > .active {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
      }
    }
    .itemBox {
      display: flex;
      width: 1200px;
      height: 354px;
      background: #ffffff;
      border: 1px solid #e8ecf4;
      box-shadow: 3px 15px 24px 0px rgba(0, 54, 125, 0.06);
      border-radius: 21px;
      margin-top: 25px;
      padding: 56px 62px;
      overflow: hidden;
      > .itemImgBox {
        width: 307px;
        height: 230px;
        background: #d9d9d9;
        border-radius: 11px;
        > img {
          width: 100%;
          height: 100%;
        }
      }
      > :last-child {
        margin-left: 53px;
        text-align: start;
        flex: 1;
        position: relative;
        > .title {
          max-height: 150px;
          max-width: 797px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 400;
          color: #4a4a4a;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
        }
        > .title:hover {
          color: #417af5;
        }

        > .subheading {
          margin-top: 47px;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 300;
          color: #4a4a4a;
        }
        > .more {
          width: 46px;
          height: 46px;
          background: #ffffff;
          border: 1px dashed #535353;
          border-radius: 50%;
          text-align: center;
          line-height: 46px;
          font-size: 30px;
          cursor: pointer;
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
    }
    .pageBox {
      margin-top: 66px;
      width: 1200px;
      margin-bottom: 113px;
    }
  }
  ::v-deep .el-pagination.is-background .btn-prev,
  ::v-deep .el-pagination.is-background .btn-next,
  ::v-deep .el-pagination.is-background .el-pager li {
    background-color: rgba(0, 0, 0, 0);
    color: #535353;
    // border: 1px solid #3e7574;
    font-size: 21px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 400;
    width: 41px;
    height: 41px;
    border-radius: 5px;
    line-height: 41px;
    border-radius: 50%;
  }

  ::v-deep .el-pagination.is-background .btn-prev .el-icon,
  ::v-deep .el-pagination.is-background .btn-next .el-icon {
    font-size: 21px;
  }

  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #364664;
  }
}

@media (max-width: 1024px) {
  .topImg {
    width: 100%;
  }
  .centerBox {
    width: 100%;
    padding: 20px 40px;
    .tabsBox {
      display: flex;
      justify-content: flex-end;
      color: #4a4a4a;
      > div {
        font-size: 12px;
        font-weight: 300;
        margin-left: 10px;
        cursor: pointer;
      }
      > .active {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
      }
    }
    .itemBox {
      display: flex;
      width: 100%;
      height: 150px;
      background: #ffffff;
      border: 1px solid #e8ecf4;
      box-shadow: 3px 15px 24px 0px rgba(0, 54, 125, 0.06);
      border-radius: 21px;
      margin-top: 10px;
      padding: 15px 15px;
      overflow: hidden;
      > .itemImgBox {
        width: 100px;
        background: #d9d9d9;
        border-radius: 11px;
        > img {
          width: 100%;
          height: 100%;
        }
      }
      > :last-child {
        margin-left: 20px;
        text-align: start;
        flex: 1;
        position: relative;
        > .title {
          max-height: 80px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 400;
          color: #4a4a4a;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        > .subheading {
          margin-top: 20px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 300;
          color: #4a4a4a;
        }
        > .more {
          width: 20px;
          height: 20px;
          background: #ffffff;
          border: 1px dashed #535353;
          border-radius: 50%;
          text-align: center;
          line-height: 20px;
          font-size: 12px;
          cursor: pointer;
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
    }
    .pageBox {
      margin-top: 20px;
    }
  }

  ::v-deep .el-pagination.is-background .btn-prev,
  ::v-deep .el-pagination.is-background .btn-next,
  ::v-deep .el-pagination.is-background .el-pager li {
    background-color: rgba(0, 0, 0, 0);
    color: #535353;
    // border: 1px solid #3e7574;
    font-size: 21px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 400;
    width: 30px;
    height: 30px;
    border-radius: 5px;
    line-height: 30px;
    border-radius: 50%;
  }

  ::v-deep .el-pagination.is-background .btn-prev .el-icon,
  ::v-deep .el-pagination.is-background .btn-next .el-icon {
    font-size: 21px;
  }

  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #364664;
  }
}
</style>
